<template>
  <div id="MyMap">
    <div style="border: solid 3px rgb(0, 94, 173)">
      <div ref="map" style="height: 400px; width: auto"></div>
    </div>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";

export default {
  name: "MyMap",
  props: {
    selectedPlaces: [],
    focusPinId: null,
  },
  data() {
    return {
      map: null,
      marker: null,
      markerList: [],
      mapiconurl: null,
      lastinfowindow: null,
      nationalCancerCenter: {
        Id: -1,
        Name: "国立がん研究センター中央病院",
        Address: "東京都中央区築地５丁目１-１",
        PhoneNumber: "03-3542-2511",
        Category: "国立がんセンター",
        Latitude: 35.66631935454085,
        Longitude: 139.76766702262375,
        EnableUrlLink: true,
        Url: "https://www.ncc.go.jp/jp/ncch/",
      },
    };
  },
  methods: {
    createContetString: function (target) {
      let targetQuery = target.Name;
      targetQuery = targetQuery.replace(/\s+/g, "");
      targetQuery = targetQuery.replace(/\n+/g, "");
      let contentString =
        "<div>" +
        '<h6 style="font-weight: bold;" >' +
        target.Name +
        "</h6>" +
        "<p>住所: " +
        target.Address +
        "</p>";
      if (target.PhoneNumber != '')
        contentString +=
        "<p>電話番号: " +
        target.PhoneNumber +
        "</p>";
      if (target.EnableUrlLink && target.Url != '')
        contentString += 
        '<p><a target="_blank" href=' +
        target.Url +
        ">" +
        "<span>病院のサイトを見る</span>"+
        "</a></p>";
      contentString +=
        '<p><a target="_blank" href=' +
        "https://www.google.com/maps/search/?api=1&query=" +
        targetQuery +
        ">" +
        "<span>Googleマップで見る</span>"+
      "</a></p></div>";
      return contentString;
    },
    // target should be a json like object
    setMarkerOnMap: function(target){
      let iconUrl = this.identifyMapIcon(target.Category);
      this.marker = new window.google.maps.Marker({
        position: {
          lat: target.Latitude,
          lng: target.Longitude,
        },
        map: this.map,
        icon:{
          url: iconUrl,
          scaledSize: new window.google.maps.Size(55,55),
        }
      });
      this.marker.set("PublicId",target.PublicId);

      let contentString = this.createContetString(target);
      const infowindow = new window.google.maps.InfoWindow({
        content: contentString,
      });
      this.addInfoWindow(infowindow, this.map, this.marker);
      this.closeInfoWindow(infowindow, this.marker);
      this.markerList.push(this.marker);
    },
    focusOnPin: function() {
      var target = this.selectedPlaces.find((el) => el.PublicId == this.focusPinId);
      var targetlatlng = new window.google.maps.LatLng(
        target.Latitude,
        target.Longitude
      );
      this.map.setCenter(targetlatlng);
      this.map.setZoom(14);
    },
    openMarkerInfoWindow: function(){
      let target = this.markerList.find(marker => marker.get("PublicId") === this.focusPinId);
      window.google.maps.event.trigger(target, 'click');
    },
    removeMarkers: function () {
      for (let index = 0; index < this.markerList.length; index++) {
        this.markerList[index].setMap(null);
      }
      this.markerList = [];
    },
    addInfoWindow: function (infowindow, map, marker) {
      marker.addListener("click", () => {
        if (this.lastinfowindow !== null)
        {
          window.google.maps.event.trigger(this.lastinfowindow, 'closeclick');
        }
        this.lastinfowindow = marker;
        infowindow.open({ map: map, anchor: marker });
      });
    },
    closeInfoWindow: function(infowindow, marker){
      marker.addListener("closeclick", () => {
        infowindow.close();
      });
    },
    identifyMapIcon: function (category) {
      let str;
      switch (category) {
        case "国立がんセンター":
          str = "/NCC_Map_Icon.png";
          break;
        case "病院":
          str = "/triangle_purple.png";
          break;
        case "診療所":
          str = "/triangle_blue.png";
          break;
        case "緩和ケア病棟がある病院":
          str = "/triangle_red.png";
          break;
        case "訪問診療可能な医療機関":
          str = "/triangle_yellow.png"
          break;
        case "健診センター":
          str = "/triangle_green.png"
          break;
        default:
          str = "/cut_red.png";
          break;
      }
      return str;
    },
    mapHelpWindow: function(controlDiv) {
      // Set CSS for the control border.
      const controlUI = document.createElement("div");

      controlUI.style.backgroundColor = "#fff";
      controlUI.style.border = "2px solid #fff";
      controlUI.style.borderRadius = "3px";
      controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
      controlUI.style.marginTop = "8px";
      controlUI.style.marginBottom = "22px";
      controlUI.style.textAlign = "left";
      controlUI.title = "Flag information";
      controlDiv.appendChild(controlUI);

      // Set CSS for the control interior.
      const controlText = document.createElement("div");

      controlText.style.color = "rgb(25,25,25)";
      // controlText.style.fontFamily = "Roboto,Arial,sans-serif";
      controlText.style.fontSize = "13px";
      controlText.style.lineHeight = "32px";
      controlText.style.paddingLeft = "5px";
      controlText.style.paddingRight = "5px";
      controlText.innerHTML = 
        '<div><img src="/triangle_purple.png" width="25" height="25"><b>病院</b></div>'
        + '<div><img src="/triangle_blue.png" width="25" height="25"><b>診療所</b></div>'
        + '<div><img src="/triangle_red.png" width="25" height="25"><b>緩和ケア病棟がある病院</b></div>'
        + '<div><img src="/triangle_yellow.png" width="25" height="25"><b>訪問診療可能な医療機関</b></div>'
        + '<div><img src="/triangle_green.png" width="25" height="25"><b>健診センター</b></div>';
      controlUI.appendChild(controlText);
    },
  },
  watch: {
    focusPinId: function () {
      this.focusOnPin();
      this.openMarkerInfoWindow();
    },
    selectedPlaces: function () {
      this.removeMarkers();
      var bounds = new window.google.maps.LatLngBounds();

      for (let index = 0; index < this.selectedPlaces.length; index++) {
        if (
          this.selectedPlaces[index].Latitude == 0 ||
          this.selectedPlaces[index].Longitude == 0
        )
          continue;

        this.setMarkerOnMap(this.selectedPlaces[index]);
        bounds.extend(this.marker.position);
        this.markerList.push(this.marker);
      }
      this.map.fitBounds(bounds);
    },
  },
  mounted: function () {
    const loader = new Loader({
      apiKey: process.env.VUE_APP_GOOGLE_APIKEY,
      version: "weekly",
    });
    loader.load().then(() => {
      this.map = new window.google.maps.Map(this.$refs.map, {
        center: {
          lat: this.nationalCancerCenter.Latitude,
          lng: this.nationalCancerCenter.Longitude,
        },
        zoom: 14,
        minZoom: 6,
        maxZoom: 18,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
      });

      const centerControlDiv = document.createElement("div");
      this.mapHelpWindow(centerControlDiv);
      this.map.controls[window.google.maps.ControlPosition.RIGHT_TOP].push(centerControlDiv);

      this.setMarkerOnMap(this.nationalCancerCenter);
    });
  },
};
</script>

<style>
a {
  text-decoration: none !important;
}
</style>
